<template>
  <div class="mobile-ticket" id="mobile-ticket">
    <div class="ticket-top">
      <header class="ticket-header">
        <!-- <MobileNav /> -->

        <!-- <img
        class="ticket-header__background"
        src="@/assets/image/ticket/header_bg.webp"
        alt="Ticket page header background illustration (decorative)"
        width="1798"
        height="1135"
        decoding="async"
        loading="lazy"
      /> -->
        <div class="ticket-header__title">
          <img
            src="@/assets/image/ticket/nav_icon_circular.webp"
            alt="Decorative lightning bolt image"
            width="190"
            height="186"
            class="ticket-header__dynamic ticket-header__dynamic-cd"
          />

          <img
            src="@/assets/image/index/mobile_header_lightning.webp"
            alt="Decorative lightning bolt image"
            width="96"
            height="96"
            decoding="async"
            class="ticket-header__dynamic ticket-header__dynamic-lightning"
          />

          <img
            class="ticket-header__title-img"
            src="@/assets/image/ticket/mobile_title.webp"
            alt="Ticket application page title graphic"
            width="769"
            height="66"
            decoding="async"
            loading="lazy"
          />
        </div>
        <!-- <img
        class="ticket-header__deco ticket-header__deco-circular"
        src="@/assets/image/ticket/nav_icon_circular.webp"
        alt="Decorative circular graphic (left)"
        width="381"
        height="381"
        decoding="async"
        loading="lazy"
      />
      <img
        class="ticket-header__deco ticket-header__deco-star"
        src="@/assets/image/ticket/nav_icon_star.webp"
        alt="Decorative star graphic (right)"
        width="319"
        height="319"
        decoding="async"
        loading="lazy"
      /> -->

        <div class="mobile-marquee mobile-marquee--banner">
          <div class="mobile-marquee-inner">
            <div class="mobile-marquee-track">
              <div
                v-for="dup in 2"
                :key="'mobile-marquee-banner-' + dup"
                class="mobile-marquee-group"
                :aria-hidden="dup === 2 ? 'true' : undefined"
              >
                <img
                  v-for="item in 10"
                  :key="`mobile-banner-${dup}-${item}`"
                  class="mobile-marquee-title"
                  src="@/assets/image/index/banner_footer_title.webp"
                  width="200"
                  height="14"
                  alt="Scrolling footer title strip (decorative)"
                  aria-hidden="true"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </header>

      <section class="ticket-description mobile-business-fade-up">
        <div class="ticket-description__region">
          <div class="ticket-description__info">
            <img
              class="ticket-description__info-logo"
              src="@/assets/image/logo/yostation.webp"
              width="100"
              height="100"
              alt="YoStation logo"
              decoding="async"
              loading="lazy"
            />
            <span class="ticket-description__info-name">
              {{ pcTicketCopy.yoStation.brandName }}
            </span>

            <div class="ticket-description__info-text">
              <div>{{ pcTicketCopy.yoStation.tagSecondary }}</div>
              <div>{{ pcTicketCopy.yoStation.tagPrimary }}</div>
            </div>
            <div class="ticket-description__info-tips">
              {{ pcTicketCopy.yoStation.cellLabels[0] }}
            </div>
            <!-- <div
              class="ticket-description__info-link ticket-description__info-share1 mobile-touch-press"
              role="button"
              tabindex="0"
              @click="openTicketQrModal"
              @keydown.enter.prevent="openTicketQrModal"
              @keydown.space.prevent="openTicketQrModal"
            > -->
            <a
              :href="pcTicketLinks.ticketInquiryFormFirst"
              target="_blank"
              rel="noopener noreferrer"
              class="ticket-description__info-link ticket-description__info-share1 mobile-touch-press"
            >
              <span>{{ pcTicketCopy.yoStation.downloadCta }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
                  fill="#FFF380"
                />
                <path
                  d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
                  fill="#FFF380"
                />
                <path
                  d="M12.3703 14H0V1.56076H6.17738V3.02787H1.45898V12.5173H10.8958V7.77257H12.3703V14Z"
                  fill="#FFF380"
                />
                <path
                  d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
                  fill="#FFF380"
                />
                <path
                  d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
                  fill="#FFF380"
                />
              </svg>
            </a>
            <!-- </div> -->
            <div class="ticket-description__info-tips">
              {{ pcTicketCopy.yoStation.cellLabels[1] }}
            </div>
            <a
              :href="pcTicketLinks.ticketInquiryForm"
              target="_blank"
              rel="noopener noreferrer"
              class="ticket-description__info-link ticket-description__info-share2 mobile-touch-press"
            >
              <span>{{ pcTicketCopy.yoStation.inquiryCta }}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
              >
                <path
                  d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
                  fill="#36E9FF"
                />
                <path
                  d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
                  fill="#36E9FF"
                />
                <path
                  d="M12.3703 14H0V1.56076H6.17738V3.02787H1.45898V12.5173H10.8958V7.77257H12.3703V14Z"
                  fill="#36E9FF"
                />
                <path
                  d="M12.6855 0.232481L2.64335 10.3306L3.74085 11.4342L13.783 1.3361L12.6855 0.232481Z"
                  fill="#36E9FF"
                />
                <path
                  d="M14 4.77592H12.4479V1.56076H9.23503V0H14V4.77592Z"
                  fill="#36E9FF"
                />
              </svg>
            </a>
          </div>
          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="361"
              height="19"
              viewBox="0 0 361 19"
              fill="none"
            >
              <path
                d="M0.5 11.0118H0V12.0118H0.5V11.5118V11.0118ZM327.904 11.5118L328.382 11.363C328.317 11.1541 328.123 11.0118 327.904 11.0118V11.5118ZM330.082 18.5L329.605 18.6488C329.664 18.8397 329.832 18.9768 330.031 18.9974C330.23 19.0179 330.422 18.9179 330.519 18.7432L330.082 18.5ZM340.101 0.5L340.595 0.421857C340.562 0.211223 340.398 0.0449096 340.188 0.00767881C339.978 -0.0295519 339.768 0.0704949 339.664 0.256831L340.101 0.5ZM341.843 11.5118L341.35 11.5899C341.388 11.8329 341.597 12.0118 341.843 12.0118V11.5118ZM360.5 12.0118C360.776 12.0118 361 11.7879 361 11.5118C361 11.2356 360.776 11.0118 360.5 11.0118V11.5118V12.0118ZM0.5 11.5118V12.0118H327.904V11.5118V11.0118H0.5V11.5118ZM327.904 11.5118L327.427 11.6605L329.605 18.6488L330.082 18.5L330.56 18.3512L328.382 11.363L327.904 11.5118ZM330.082 18.5L330.519 18.7432L340.538 0.743169L340.101 0.5L339.664 0.256831L329.645 18.2568L330.082 18.5ZM340.101 0.5L339.607 0.578143L341.35 11.5899L341.843 11.5118L342.337 11.4336L340.595 0.421857L340.101 0.5ZM341.843 11.5118V12.0118H360.5V11.5118V11.0118H341.843V11.5118Z"
                fill="#FFF380"
              />
            </svg>
          </div>

          <div
            class="ticket-session mobile-business-fade-up mobile-business-fade-up--delay-1"
          >
            <div
              v-for="tier in ticketTiersWithRows"
              :key="tier.id"
              class="ticket-session__item mobile-touch-press"
            >
              <div
                class="ticket-session__item-title"
                :class="'ticket-session__item-' + tier.variant"
              >
                <div class="ticket-session__item-title--num">
                  <div>{{ tier.id }}</div>
                </div>
                <div class="ticket-session__item-title--right">
                  <div class="ticket-session__item-title--floor">
                    {{ tier.title }}
                  </div>
                  <div class="ticket-session__item-title--price">
                    {{ tier.priceLabel }}
                  </div>
                </div>
              </div>
              <ul class="ticket-session__item-detail">
                <li v-for="row in tier.rows" :key="tier.id + '-' + row.label">
                  <span class="ticket-session__item-label">{{
                    row.label
                  }}</span>
                  <span class="ticket-session__item-value">{{
                    row.value
                  }}</span>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="361"
              height="19"
              viewBox="0 0 361 19"
              fill="none"
            >
              <path
                d="M0.5 11.0118H0V12.0118H0.5V11.5118V11.0118ZM327.904 11.5118L328.382 11.363C328.317 11.1541 328.123 11.0118 327.904 11.0118V11.5118ZM330.082 18.5L329.605 18.6488C329.664 18.8397 329.832 18.9768 330.031 18.9974C330.23 19.0179 330.422 18.9179 330.519 18.7432L330.082 18.5ZM340.101 0.5L340.595 0.421857C340.562 0.211223 340.398 0.0449096 340.188 0.00767881C339.978 -0.0295519 339.768 0.0704949 339.664 0.256831L340.101 0.5ZM341.843 11.5118L341.35 11.5899C341.388 11.8329 341.597 12.0118 341.843 12.0118V11.5118ZM360.5 12.0118C360.776 12.0118 361 11.7879 361 11.5118C361 11.2356 360.776 11.0118 360.5 11.0118V11.5118V12.0118ZM0.5 11.5118V12.0118H327.904V11.5118V11.0118H0.5V11.5118ZM327.904 11.5118L327.427 11.6605L329.605 18.6488L330.082 18.5L330.56 18.3512L328.382 11.363L327.904 11.5118ZM330.082 18.5L330.519 18.7432L340.538 0.743169L340.101 0.5L339.664 0.256831L329.645 18.2568L330.082 18.5ZM340.101 0.5L339.607 0.578143L341.35 11.5899L341.843 11.5118L342.337 11.4336L340.595 0.421857L340.101 0.5ZM341.843 11.5118V12.0118H360.5V11.5118V11.0118H341.843V11.5118Z"
                fill="#FFF380"
              />
            </svg>
          </div>

          <div class="ticket-attention">
            <div
              class="ticket-attention__heading"
              v-html="pcTicketCopy.noticeHeadingHtml"
            />
            <ul>
              <li v-for="(line, idx) in noticeLines" :key="'n-' + idx">
                <span v-html="'※' + line"></span>
              </li>
            </ul>
          </div>
        </div>
        <div class="mobile-marquee mobile-marquee--description">
          <div class="mobile-marquee-inner">
            <div class="mobile-marquee-track">
              <div
                v-for="dup in 2"
                :key="'mobile-marquee-banner-' + dup"
                class="mobile-marquee-group"
                :aria-hidden="dup === 2 ? 'true' : undefined"
              >
                <img
                  v-for="item in 10"
                  :key="`mobile-banner-${dup}-${item}`"
                  class="mobile-marquee-title"
                  src="@/assets/image/index/banner_footer_title.webp"
                  width="200"
                  height="14"
                  alt="Scrolling footer title strip (decorative)"
                  aria-hidden="true"
                  decoding="async"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>

    <div
      class="ticket-timeline mobile-business-fade-up mobile-business-fade-up--delay-2"
    >
      <!-- DJ：背景无限横向滚动 -->
      <div class="ticket-timeline__layer" aria-hidden="true">
        <div class="ticket-timeline__layer-track">
          <div
            v-for="dup in 2"
            :key="'dj-bg-slab-' + dup"
            class="ticket-timeline__layer-slab"
          />
        </div>
      </div>

      <div
        class="ticket-timeline__row"
        v-for="(item, index) in timelineList"
        :key="item.type"
      >
        <div class="ticket-timeline__row-date" v-if="item.year">
          <div class="ticket-timeline__row-date--year">{{ item.year }}</div>
        </div>
        <div class="ticket-timeline__row-date" v-if="!item.year">
          <div class="ticket-timeline__row-date--line" v-if="index"></div>
          <div>
            <div class="ticket-timeline__row-date--day">{{ item.date }}</div>
            <div
              class="ticket-timeline__row-date--week"
              :style="{ color: item.week === 'TUE' ? '#FF835D' : '#36e9ff' }"
            >
              {{ item.weekLabel }}
            </div>
          </div>
        </div>
        <div
          v-if="!item.year"
          class="ticket-timeline__row-card"
          :style="{
            'border-color': item.themeColor,
            'box-shadow': `inset 0 0 6px 1px ${
              item.themeColor
            }, 0 0 6px ${getLightColor(item.themeColor)}`,
          }"
        >
          <img
            class="ticket-timeline__row-card--type"
            :src="timelineTypeImgMap[item.type]"
            alt="Timeline type image"
            width="195"
            height="60"
          />
          <span class="ticket-timeline__row-card--arrow">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="21"
              viewBox="0 0 18 21"
              fill="none"
            >
              <path
                d="M5.24537e-07 10.3926L18 20.7849L18 0.000272918L5.24537e-07 10.3926Z"
                :fill="item.themeColor"
              />
            </svg>
          </span>
          <div class="ticket-timeline__row-card--content">
            <div
              v-for="(row, ri) in item.scheduleLines"
              :key="ri"
              class="ticket-timeline__row-card--line"
              :class="{
                'ticket-timeline__row-card--line--last':
                  ri === item.scheduleLines.length - 1,
              }"
              :style="
                ri === item.scheduleLines.length - 1
                  ? { borderTopColor: item.themeColor }
                  : null
              "
            >
              <span
                class="ticket-timeline__row-card--line-label"
                :style="{ backgroundColor: item.themeColor }"
                >{{ row.label }}</span
              >
              <span class="ticket-timeline__row-card--line-value">{{
                row.value
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <transition name="mobile-ticket-qr-modal">
      <div
        v-show="ticketQrModalVisible"
        class="mobile-index__ticket-qr-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-ticket-qr-modal-title"
        @click.self="closeTicketQrModal"
      >
        <h2
          id="mobile-ticket-qr-modal-title"
          class="mobile-index__ticket-qr-modal__sr-only"
        >
          {{ pcTicketCopy.ticketQrModal.dialogTitle }}
        </h2>
        <button
          type="button"
          class="mobile-index__ticket-qr-modal__close"
          :aria-label="pcTicketCopy.ticketQrModal.closeLabel"
          @click="closeTicketQrModal"
        >
          <img
            src="@/assets/image/detail/close.webp"
            width="40"
            height="40"
            alt=""
            decoding="async"
          />
        </button>
        <div class="mobile-index__ticket-qr-modal__inner">
          <div class="mobile-index__ticket-qr-modal__qr-frame">
            <img
              class="mobile-index__ticket-qr-modal__qr"
              src="@/assets/image/logo/qr.webp"
              width="360"
              height="360"
              :alt="pcTicketCopy.imgAlt.yoStationQr"
              decoding="async"
            />
          </div>
          <p class="mobile-index__ticket-qr-modal__caption">
            {{ pcTicketCopy.ticketQrModal.caption }}
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { scrollToAnchorById } from "@/utils/mobile-anchor";
import ticketContent from "@/views/data/ticket-content.json";

/** 与 PC 票务时间轴一致：日程文案来自 ticket-content.json の ticketTimelineCities（scheduleLines 原样展示） */
function buildMobileTicketTimelineList(year, cities) {
  const themeColorByVariant = {
    sapporo: "#36E9FF",
    fukuoka: "#D9A2FF",
    nagoya: "#54FFBD",
    osaka: "#FFAB91",
    tokyo: "#FFF6A2",
  };
  const rows = [{ year }];
  for (const city of cities) {
    rows.push({
      date: city.dateLine,
      week: city.dowDistinguished ? "TUE" : "SAT",
      weekLabel: city.dow,
      type: city.variant,
      themeColor:
        themeColorByVariant[city.variant] || themeColorByVariant.sapporo,
      scheduleLines: city.scheduleLines,
    });
  }
  return rows;
}

/**
 * 移动端票务页：文案、外链、票种/注意事项/时间轴等均来自 ticket-content.json（与 PC 票务同源）
 */
export default {
  name: "MTicket",
  data() {
    const page = ticketContent;
    return {
      pcTicketCopy: page.pcTicketCopy,
      pcTicketLinks: page.pcTicketLinks,
      ticketQrModalVisible: false,
      timelineCardsRevealed: false,
      ticketTiers: page.ticketTiers,
      noticeLines: page.noticeLines,
      ticketTierDetailRows: page.ticketTierDetailRows,
      timelineList: buildMobileTicketTimelineList(
        page.ticketTimelineYear,
        page.ticketTimelineCities,
      ),
      timelineTypeImgMap: {
        sapporo: require("@/assets/image/ticket/mobile_sapporo.webp"),
        fukuoka: require("@/assets/image/ticket/mobile_fukuoka.webp"),
        nagoya: require("@/assets/image/ticket/mobile_nagoya.webp"),
        osaka: require("@/assets/image/ticket/mobile_osaka.webp"),
        tokyo: require("@/assets/image/ticket/mobile_tokyo.webp"),
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      scrollToAnchorById("mobile-ticket", { behavior: "auto", block: "start" });
    });
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this._onTicketQrModalKeydown);
    if (this.ticketQrModalVisible) {
      document.body.style.overflow = "";
    }
  },
  computed: {
    ticketTiersWithRows() {
      return this.ticketTiers.map((t) => ({
        ...t,
        rows: this.ticketTierDetailRows,
      }));
    },
  },
  methods: {
    openTicketQrModal() {
      document.removeEventListener("keydown", this._onTicketQrModalKeydown);
      document.addEventListener("keydown", this._onTicketQrModalKeydown);
      this.ticketQrModalVisible = true;
      document.body.style.overflow = "hidden";
    },
    closeTicketQrModal() {
      this.ticketQrModalVisible = false;
      document.body.style.overflow = "";
      document.removeEventListener("keydown", this._onTicketQrModalKeydown);
    },
    _onTicketQrModalKeydown(e) {
      if (e.key === "Escape") {
        this.closeTicketQrModal();
      }
    },
    // 自动根据主题色生成 30% 透明度的发光色
    getLightColor(color) {
      return color + "4D"; // 4D = 透明度 30%，和你原来 0.3 完全一致
    },
  },
};
</script>

<style scoped lang="scss">
.mobile-ticket {
  color: #fff;
  font-family: 'Noto Sans JP', 'Noto Sans', sans-serif;

  background-color: #3c3068;
}

.ticket-top {
  position: relative;
  background-image: url("@/assets/image/streaming/mobile_bg.webp");
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: scroll;
  z-index: 0;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    top: 230px;
    width: 100%;
    height: 100%;
    background-image: url(@/assets/image/streaming/mobile_bg_icon.webp);
    background-position: top left; /* 保持你要的左上角对齐 */
    background-size: 130% auto;
    background-repeat: no-repeat;
    animation: BackgroundFloat 6s ease-in-out infinite;
    z-index: 1;
  }
}

.ticket-header {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  z-index: 2;

  &__background {
    position: absolute;

    width: 100%;
    object-fit: contain;
    object-position: center;
  }

  &__dynamic {
    position: absolute;
    object-fit: contain;
    object-position: center;
    transform-origin: center center;
    will-change: transform;
    animation: mobile-header-img-dynamic 1.35s infinite;

    position: absolute;
    z-index: 9;

    &-cd {
      top: 0px;
      left: -70px;
    }
    &-lightning {
      top: 90px;
      right: 30px;
    }
  }

  &__title {
    padding: 90px 132px 66px;
  }

  &__deco {
    position: absolute;
    object-fit: contain;
    object-position: center;
    transform-origin: center center;
    will-change: transform;
    animation: ticket-deco-beat 1.35s infinite;

    &-circular {
      top: 39px;
      left: 204px;
      width: 300px;
    }

    &-star {
      top: 71px;
      right: 188px;
      width: 227px;
    }
  }
}

.ticket-description {
  position: relative;
  padding: 32px 40px 70px;
  z-index: 2;

  &__region {
    border: 1px solid #fff380;
    border-radius: 8px;
  }

  &__info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 80px 50px;

    &-logo {
      margin-bottom: 8px;
    }

    &-name {
      margin-bottom: 28px;
      color: #fff;
      font-size: 18px;
      font-weight: 700;
      line-height: 100%;
    }

    &-text div:first-child {
      margin-bottom: 10px;
    }
    &-text {
      width: 100%;
      margin-bottom: 28px;
      padding: 10px 20px;
      color: #36e9ff;
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
      background: rgba(0, 0, 0, 0.25);
      border-radius: 8px;
    }

    &-tips {
      width: 100%;
      padding: 2px 0;
      text-align: center;
      border: 1px solid #fff;
    }

    &-link {
      display: flex;
      justify-content: center;
      gap: 4px;
      width: 100%;
      padding: 10px 0;
      font-size: 14px;
      font-weight: 600;
      line-height: 100%;
      text-decoration: none;
      color: inherit;
      box-sizing: border-box;
    }

    &-share1 {
      margin-bottom: 36px;
      border-bottom: 1px solid #fff380;
      color: #fff380;
    }
    &-share2 {
      //   margin-bottom: 18px;
      color: #36e9ff;
      border-bottom: 1px solid #36e9ff;
    }
  }
}

.ticket-session {
  padding: 30px 18px;

  &__item + &__item {
    margin-top: 28px;
  }

  &__item {
    // margin-bottom: 32px;
    // padding: 30px 20px 15px;
    border-radius: 8px;
    // background: rgba(255, 255, 255, 0.1);
    -webkit-tap-highlight-color: transparent;

    &-gold {
      color: #fff380;

      .ticket-session__item-title--num div {
        background: #fff380;
      }
    }

    &-cyan {
      color: #36e9ff;

      .ticket-session__item-title--num div {
        background: #36e9ff;
      }
    }

    &-title {
      display: flex;
      align-items: center;
      gap: 10px;
      margin-bottom: 12px;

      &--num {
        width: 72px;
        display: flex;
        align-items: center;
        justify-content: center;

        div {
          display: flex;
          width: 40px;
          height: 40px;
          justify-content: center;
          align-items: center;
          border-radius: 20px;
          background: #fff380;
          color: #000;
          font-size: 16px;
          font-weight: 600;
        }
      }

      &--right {
        padding: 8px 30px;
        border-bottom: 1px solid #fff;
        text-align: left;
        font-weight: 600;
      }

      &--floor {
        font-size: 16px;
      }

      &--price {
        color: #fff;
        font-size: 14px;
      }
    }

    &-detail {
      display: flex;
      flex-direction: column;
      gap: 4px;

      li {
        display: flex;
        align-items: center;
        gap: 10px;
      }
    }

    &-label {
      width: 72px;
      padding: 2px 10px;
      font-size: 12px;
      font-weight: 600;
      text-align: center;
      background: rgba(0, 0, 0, 0.25);
    }
    &-value {
      font-size: 14px;
      font-weight: 500;
      line-height: 100%;
      text-align: left;
    }
  }
}

.ticket-attention {
  padding: 30px 30px 40px;
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  line-height: 200%;

  &__heading {
    margin-bottom: 0.5em;
  }

  ul {
    margin: 0;
    padding: 0;
    list-style: none;

    li {
      display: block;
      margin-bottom: 10px;
      text-indent: -1.2em;
      padding-left: 1.2em;
    }
  }
}

.ticket-timeline {
  padding: 120px 30px 84px;

  &__layer {
    position: absolute;
    inset: 0;
    z-index: 1;
    overflow: hidden;
    pointer-events: none;

    &-track {
      display: flex;
      height: 100%;
      width: max-content;
      animation: ticket-timeline-bg-marquee 20s linear infinite;
      will-change: transform;

      @media (prefers-reduced-motion: reduce) {
        animation: none;
        will-change: auto;
      }
    }

    &-slab {
      flex-shrink: 0;
      width: 100vw;
      min-height: 918px;
      height: 100%;
      background-image: url("@/assets/image/index/mobile_dj_bg.webp");
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }

  &__row + &__row {
    margin-top: 20px;
  }

  &__row {
    display: flex;
    align-items: flex-end;
    gap: 30px;

    &-date {
      width: 90px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 20px;

      &--year {
        font-size: 16px;
        font-weight: 700;
        line-height: 100%;
        letter-spacing: 1.6px;
      }

      &--line {
        // flex: 1;
        width: 2px;
        height: 94px;
        flex-shrink: 0;
        background-color: #fff380;
      }

      &--day {
        font-size: 24px;
        font-weight: 700;
        line-height: 200%;
        letter-spacing: 2.4px;
      }

      &--week {
        font-size: 16px;
        font-weight: 700;
        line-height: 200%;
        letter-spacing: 1.6px;
      }
    }

    &-card {
      position: relative;
      //   flex: 1;
      margin-bottom: 30px;
      padding: 38px 28px 20px;
      transition: opacity 0.75s cubic-bezier(0.22, 1, 0.32, 1),
        transform 0.75s cubic-bezier(0.22, 1, 0.32, 1), box-shadow 0.22s ease;
      border: 2px solid;
      border-radius: 6px;
      background: rgba(0, 0, 0, 0.1);
      box-sizing: border-box;
      -webkit-tap-highlight-color: transparent;

      &:active {
        transform: scale(0.99);
        transition-duration: 0.12s;
      }

      &--type {
        position: absolute;
        top: -24px;
        left: 50%;
        transform: translateX(-50%);
      }

      &--arrow {
        position: absolute;
        bottom: 12px;
        left: -20px;
        // transform: translateX(100%);
      } 

      &--line {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
        font-size: 12px;
        font-weight: 700;
        line-height: 100%;

        &--last {
          border-top: 2px solid transparent;
          padding-top: 12px;
          margin-top: 6px;
          margin-bottom: 0;
        }
      }

      &--line-label {
        flex-shrink: 0;
        width: 46px;
        padding: 2px 4px;
        border-radius: 2px;
        color: #191616;
        text-align: center;
        font-size: 10px;
        font-weight: 700;
        line-height: 100%;
      }

      &--line-value {
        flex: 1;
        min-width: 0;
        text-align: left;
      }
    }
  }
}

@media (prefers-reduced-motion: reduce) {
  .ticket-timeline__row-card:active {
    transform: none;
  }
}

/* 无限滚动横幅 */
.mobile-marquee {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 60px;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;

  background-image: url("@/assets/image/index/banner_footer_bg.webp");

  &--description {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -28px;
    z-index: 9;
  }

  &-inner {
    width: 100%;
    height: 24px;
    overflow: hidden;
    background-color: #191616;
    display: flex;
    align-items: center;
    border-top: 2px solid #fff590;
    border-bottom: 2px solid #fff590;
  }

  &-track {
    display: flex;
    width: max-content;
    flex-shrink: 0;
    align-items: center;
    animation: mobile-marquee 30s linear infinite;
    will-change: transform;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
      will-change: auto;
    }
  }

  &-group {
    display: flex;
    flex-shrink: 0;
    align-items: center;
  }

  &-title {
    flex-shrink: 0;
    margin-right: 20px;
    width: 200px;
    height: 10px;
    object-fit: contain;
    object-position: center;
  }
}

/* 无限滚动动画 */
@keyframes mobile-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

@keyframes mobile-header-img-dynamic {
  0%,
  42% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.45, 0, 0.55, 1);
  }
  52% {
    transform: scale(0.9);
    animation-timing-function: cubic-bezier(0.55, 0.05, 0.6, 0.45);
  }
  58% {
    transform: scale(0.86);
    animation-timing-function: cubic-bezier(0.33, 1.15, 0.52, 1);
  }
  70% {
    transform: scale(1.08);
    animation-timing-function: cubic-bezier(0.22, 0.85, 0.38, 1);
  }
  80% {
    transform: scale(1);
    animation-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  }
  100% {
    transform: scale(1);
  }
}

/* YoStation 下载 QR 全屏弹窗（与首页 mobile-index ticket 区一致） */
.mobile-index__ticket-qr-modal {
  position: fixed;
  inset: 0;
  z-index: 200;
  background-color: #35353c;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: calc(56px + env(safe-area-inset-top, 0)) 20px
    calc(24px + env(safe-area-inset-bottom, 0));
  box-sizing: border-box;
  border-top: 2px solid #c84cff;
  border-bottom: 2px solid #c84cff;
  box-shadow: 0 -8px 22px -2px rgba(191, 0, 255, 0.55),
    0 8px 22px -2px rgba(191, 0, 255, 0.55),
    0 -18px 40px -6px rgba(200, 76, 255, 0.35),
    0 18px 40px -6px rgba(200, 76, 255, 0.35);

  &__sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  &__close {
    position: absolute;
    top: calc(16px + env(safe-area-inset-top, 0));
    right: max(16px, env(safe-area-inset-right, 0));
    width: 40px;
    height: 40px;
    padding: 0;
    margin: 0;
    border: none;
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 0;
    border-radius: 50%;
    transform-origin: center center;
    -webkit-tap-highlight-color: transparent;
    transition: transform 0.24s cubic-bezier(0.34, 1.45, 0.64, 1),
      filter 0.2s ease, background-color 0.2s ease, box-shadow 0.24s ease;

    img {
      display: block;
      width: 40px;
      height: 40px;
      object-fit: contain;
      pointer-events: none;
      transition: transform 0.24s cubic-bezier(0.34, 1.45, 0.64, 1),
        filter 0.2s ease;
    }

    &:active {
      transform: scale(0.92);
      filter: brightness(0.92);
      transition-duration: 0.08s;

      img {
        transform: rotate(90deg) scale(0.95);
        transition-duration: 0.08s;
      }
    }

    &:focus-visible {
      outline: 2px solid #fff380;
      outline-offset: 2px;
    }
  }

  &__inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    max-width: 100%;
  }

  &__qr-frame {
    background-color: #fff;
    padding: 16px;
    box-sizing: border-box;
    line-height: 0;
    max-width: 100%;
    border-radius: 8px;
    overflow: hidden;
  }

  &__qr {
    display: block;
    width: 360px;
    height: 360px;
    max-width: 100%;
    max-height: min(360px, 50vh);
    object-fit: contain;
  }

  &__caption {
    margin: 20px 0 0;
    padding: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.5;
    text-align: center;
  }
}

@keyframes ticket-timeline-bg-marquee {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active {
  transition: opacity 0.32s cubic-bezier(0.4, 0, 0.2, 1);
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active
  .mobile-index__ticket-qr-modal__inner,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active
  .mobile-index__ticket-qr-modal__inner {
  transition: transform 0.4s cubic-bezier(0.34, 1.18, 0.64, 1),
    opacity 0.32s ease;
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to {
  opacity: 0;
}

.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter
  .mobile-index__ticket-qr-modal__inner,
.mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to
  .mobile-index__ticket-qr-modal__inner {
  opacity: 0;
  transform: scale(0.92) translateY(20px);
}

@media (prefers-reduced-motion: reduce) {
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter-active
    .mobile-index__ticket-qr-modal__inner,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-active
    .mobile-index__ticket-qr-modal__inner {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-enter
    .mobile-index__ticket-qr-modal__inner,
  .mobile-index__ticket-qr-modal.mobile-ticket-qr-modal-leave-to
    .mobile-index__ticket-qr-modal__inner {
    transform: none !important;
    opacity: 1 !important;
  }

  .mobile-index__ticket-qr-modal__close,
  .mobile-index__ticket-qr-modal__close img {
    transition: none !important;
  }

  .mobile-index__ticket-qr-modal__close:active {
    transform: none !important;
    filter: none !important;
  }

  .mobile-index__ticket-qr-modal__close:active img {
    transform: none !important;
  }
}

@keyframes BackgroundFloat {
  0% {
    background-position: top left;
    background-size: 130% auto;
    opacity: 0.85;
  }

  50% {
    /* 中心对称放大 → 向四周扩散 */
    background-position: top -60px left -60px;
    background-size: 150% auto;
    opacity: 1;
  }

  100% {
    /* 回到初始位置 */
    background-position: top left;
    background-size: 130% auto;
    opacity: 0.85;
  }
}
</style>
